<template>
  <v-app>
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-TSR4KVG"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      />
    </noscript>
    <transition name="fade-transition" mode="out-in"> <router-view /> </transition>
    <snack-bar />
    <!-- <help /> -->
  </v-app>
</template>

<script>
import SnackBar from './components/layout/SnackBar';
import Help from './components/Help';

export default {
  components: { SnackBar, Help },

  updated() {
    if (!localStorage.getItem('helpMenu') && !this.$route.meta.noHelp) {
      this.$store.commit('helpMenu', true);
      localStorage.setItem('helpMenu', 1);
    }
  },
};
</script>

<style lang="scss">
.pre {
  white-space: pre-wrap;
}
.tui-full-calendar-weekday-resize-handle {
  display: none !important;
}

.v-messages {
  display: none !important;
}
.v-input--selection-controls {
  margin-top: 2px !important;
}
.v-card__text title {
  margin-bottom: 2px !important;
}
.handle-y {
  display: none !important;
}
.ie {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  z-index: 10000;

  span {
    font-size: 24px;
    display: inline-block;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 40%;
  }
}

th {
  &.text--vertical,
  .text--vertical {
    writing-mode: vertical-lr;
  }
}

.objective-table {
  thead tr:first-child th:not(:first-child) {
    vertical-align: bottom;
  }

  thead > tr:nth-child(2) > th:nth-child(1) {
    width: 36px;
  }

  thead > tr:nth-child(2) > th:nth-child(2) {
    width: 99%;
  }
}

.layout.layout__no-margins {
  margin: auto 0 !important;
}

.v-flex {
  display: flex;
}

.v-flex-inline {
  display: inline-flex;
}

.no-outline {
  outline: none;
}

.w-100 {
  width: 100% !important;
}

.d-inline {
  display: inline-block !important;
}

.grow-0 {
  flex-grow: 0 !important;
}

.grow-1 {
  flex-grow: 1 !important;
}

.vue-star-rating {
  display: flex;
  align-items: center;

  .vue-star-rating-rating-text {
    margin-top: 0 !important;
  }
}

.self-center {
  align-self: center;
}

.selectable {
  user-select: text !important;

  .list__tile {
    user-select: text !important;
    height: auto !important;
  }
}

.no-stretch {
  width: 1%;
  white-space: nowrap !important;
  padding: 0 16px !important;
}

table {
  outline: none;

  thead tr th {
    outline: none;
  }

  .percentage-row {
    min-width: 600px;
  }

  .no-hover:hover {
    background: inherit !important;
  }

  .table-subheader {
    background: #eee;
    cursor: default;
    border-bottom: none !important;

    td {
      height: 32px !important;
    }
  }
}

.no-wrap {
  white-space: nowrap;
}

.v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue